import React from "react";
import { Button, ButtonGroup } from "@mui/material";

const ButtonGroupCustom = ({active, setActive, items = []}) => {
  return (
    <ButtonGroup variant="outlined" className="d-flex">
      {
        items.map((i, index) => (
          <Button 
            key={`button-group-item-${i}-${index}`}
            onClick={() => setActive(index)}
            className={`${active === index ? 'active' : ''} flex-grow-1 px-2 px-md-3`}>{i}</Button>
        ))
      }
    </ButtonGroup>
  );
};

export default ButtonGroupCustom;
